import track from './track';
import getProductData from './get-product-data';
import { debounce, sortBy } from 'lodash';

const impressions = [];

/**
 * Track a product impression
 * @param {IProduct} product - product model
 */
export default function productImpression(product) {
    // queue the impressions
    impressions.push({
        ...getProductData(product),
        list: product.list,
    });

    // dispatch a deferred event every second
    debouncedTrack();
}

const debouncedTrack = debounce(() => {
    track({
        event: 'productImpression',
        ecommerce: {
            currencyCode: 'CHF',
            impressions: sortBy([...impressions], 'position'),
        },
    });

    // empty impressions array
    impressions.splice(0, impressions.length);
}, 1000);



// WEBPACK FOOTER //
// ./mcart/assets/src/js/app/tracking/product-impression.js